import { createRoot } from "react-dom/client";
import { PostHogProvider } from "posthog-js/react";
import App from "./App.tsx";
import "./index.css";

// Check debug mode for Clarity (before it initializes)
const debugMode = localStorage.getItem('debug_mode') === 'true';
if (debugMode && window.clarity) {
  // Disable Clarity by replacing with no-op
  (window as any).clarity = () => {};
}

const posthogOptions = {
  api_host: "https://t.ai-lens.app",
  ui_host: "https://eu.i.posthog.com",
  autocapture: true,
  capture_pageview: true,
  capture_exceptions: true,
  session_recording: {
    maskAllInputs: false,
    maskTextSelector: null,
  },
};

createRoot(document.getElementById("root")!).render(
  <PostHogProvider
    apiKey="phc_utTq09mw2r5VF8zRfy3WkKrRXdnfkvDx8HaulwPAN1H"
    options={posthogOptions}
  >
    <App />
  </PostHogProvider>
);
